<script setup lang="ts">
import { CheckboxItemInterface } from '@/types';
import { computed } from 'vue';

interface PropsInterface {
  items?: Array<CheckboxItemInterface> | null;
  title: string;
  className?: string | null;
  updateItem: (id: string, checked: boolean) => void;
  cancel: () => void;
  save: () => void;
  dirty: boolean;
  loading?: boolean;
  disabled?: boolean;
}

const props = defineProps<PropsInterface>();

const loadingOrSaving = computed(() => props.loading && (!props.items || props.items.length === 0));
</script>

<template>
  <FormCard
    :title="title"
    :dirty="dirty"
    :cancel="cancel"
    :save="save"
    content-class-name="start"
    :class-name="className"
  >
    <template #form>
      <div v-if="loadingOrSaving">
        <Skeleton v-for="n in 5" :key="n" width="100%" height="24px" />
      </div>
      <form>
        <div v-for="item in items" :key="item.id" class="field">
          <Checkbox
            :id="item.name"
            v-model="item.checked"
            :value="item.checked"
            :binary="true"
            :disabled="loadingOrSaving || disabled"
            @change="updateItem(item.id, item.checked as boolean)"
          />
          <label class="font-bold" :for="item.name">{{ item.name }}</label>
        </div>
        <slot />
      </form>
    </template>
  </FormCard>
</template>

<style scoped lang="scss">
.checkbox-form {
  height: 100%;

  :deep(.p-card-content) {
    margin-top: 0;
    align-items: start !important;

    .p-skeleton {
      margin: 6px 0;
    }
    .field {
      display: flex;
      align-content: center;
      padding: 0;
      margin: 6px 0;
      height: 24px !important;

      .p-checkbox-box {
        color: white;
        border: 2px solid #d4d9d9;
        width: 18px;
        height: 18px;

        &.p-highlight {
          background-color: #8bcfcf;
          border: 2px solid #8bcfcf;
        }
      }

      .p-checkbox-icon {
        color: white;
      }

      label {
        font-weight: 500;
        font-size: 14px;
        margin-left: 9px;
        line-height: 18px;
        font-family: 'Rubik', sans-serif;
      }
    }
  }
}
</style>
